var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 24.375C26.25 26.1009 24.8509 27.5 23.125 27.5C21.3991 27.5 20 26.1009 20 24.375C20 22.6491 21.3991 21.25 23.125 21.25C24.8509 21.25 26.25 22.6491 26.25 24.375Z",
    stroke: "#676767",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 11.875C26.25 13.6009 24.8509 15 23.125 15C21.3991 15 20 13.6009 20 11.875C20 10.1491 21.3991 8.75 23.125 8.75C24.8509 8.75 26.25 10.1491 26.25 11.875Z",
    stroke: "#676767",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.125C10 19.8509 8.60089 21.25 6.875 21.25C5.14911 21.25 3.75 19.8509 3.75 18.125C3.75 16.3991 5.14911 15 6.875 15C8.60089 15 10 16.3991 10 18.125Z",
    stroke: "#676767",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.625C10 7.35089 8.60089 8.75 6.875 8.75C5.14911 8.75 3.75 7.35089 3.75 5.625C3.75 3.89911 5.14911 2.5 6.875 2.5C8.60089 2.5 10 3.89911 10 5.625Z",
    stroke: "#676767",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5.625L19.375 11.875L10.625 18.125L20 24.375",
    stroke: "#676767",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/Task.00a83c5cdaf493168528cc166210d9b3.svg";
export { ForwardRef as ReactComponent };